import { Controller } from "@hotwired/stimulus"

// Controla o auto-resize de textareas e trix-editors
export default class extends Controller {
  connect() {
    // Faz o resize inicial com delay para garantir que o elemento está pronto
    setTimeout(() => this.resize(), 100)
  }

  resize() {
    const element = this.element
    
    // Se for um trix-editor
    if (element.tagName.toLowerCase() === 'trix-editor') {
      // Verifica se o editor está inicializado
      if (!element.editor || !element.editor.getDocument) {
        return
      }
      
      try {
        // Reseta a altura para calcular o tamanho correto
        element.style.height = 'auto'
        
        // Pega a altura do conteúdo interno
        const contentElement = element.querySelector('.trix-content')
        if (contentElement) {
          const contentHeight = element.editor.getDocument().getLength() > 0
            ? contentElement.scrollHeight
            : parseInt(element.getAttribute('data-min-height') || '100')
          
          // Ajusta a altura com um pequeno padding
          element.style.height = `${contentHeight + 20}px`
        }
      } catch (error) {
        console.warn('Erro no auto-resize do trix-editor:', error)
        // Fallback para altura mínima
        element.style.height = element.getAttribute('data-min-height') || '100px'
      }
    } else {
      // Para textareas normais
      if (element.scrollHeight) {
        element.style.height = 'auto'
        element.style.height = `${element.scrollHeight}px`
      }
    }
  }
} 